import axios from "axios";
import { apiBaseUrl } from "../../../helpers/UrlHelper";
import { loginToken } from "../../../helpers/LocalStorageHelper";
import { handleError } from "../../../helpers/ErrorHelper";

function _success(success) {
  return { type: "GET_SITE_FAILED_SUCCESS", success };
}
function _error(error) {
  return { type: "GET_SITE_FAILED_ERROR", error };
}
function _processing(processing) {
  return { type: "GET_SITE_FAILED_PROCESSING", processing };
}

function getSiteFailedTnx(id, org_id = null) {
  return (dispatch, getState) => {
    dispatch(_processing(true));
    dispatch(_success(null));
    dispatch(_error(null));

    const { organization_id } = getState().organizationDashboard.data;

    const { params } = getState().siteFailedTnxList?.data;

    axios({
      url: apiBaseUrl(
        `admin/organizations/${
          org_id || organization_id
        }/sites/${id}/failed-site-transactions`
      ),
      method: "get",
      dataType: "json",
      params,
      headers: { Authorization: "Bearer " + loginToken() },
    })
      .then(function (res) {
        dispatch(_success(res?.data?.data));
        dispatch(_processing(false));
      })
      .catch(function (error) {
        handleError(error);
        dispatch(_error(error));
        dispatch(_processing(false));
      });
  };
}

export default getSiteFailedTnx;
